import { CrudBuilderConfig } from '../../components/crudbuilder/models/crud-builder-config';
import ListFormatter from '../../helpers/list-formatter';
import Formatter from '../../helpers/formatter';
import { FieldConfig } from '../../components/crudbuilder/models/field-config';
import { createHome, Home } from '../../state/homes/home.model';
import HasOneField from '@core/components/crudbuilder/models/has-one-field';
import { HasoneAddressCrudBuilderConfig } from '@core/pages/crud/hasone/hasone-address-crud-builder-config';

class HomesCrudBuilderConfigClass extends CrudBuilderConfig {
  singular   = 'Home';
  customTitle = 'Vul de gegevens van uw huis in';
  plural     = 'Huizen';
  modelAlias = 'home';
  path       = 'homes';
  hasCustomizedEditTitle = true;

  fields     = [
    new FieldConfig('person_id', 'person', 'Persoon'),
    new FieldConfig('price', FieldConfig.TYPE_MONEY, 'Aankoopbedrag'),
    new FieldConfig('woz', FieldConfig.TYPE_MONEY, 'WOZ waarde'),
    new FieldConfig('construction_type_configuration_id', FieldConfig.TYPE_RELATIONCONFIG, 'Soort woning', 'construction-type'),
    new FieldConfig('construction_year', FieldConfig.TYPE_NUMBER, 'Bouwjaar'),
    new FieldConfig('home_type_configuration_id', FieldConfig.TYPE_RELATIONCONFIG, 'Type Huis', 'home-type'),
    new FieldConfig('market_value', FieldConfig.TYPE_NUMBER, 'Marktwaarde'),
    new FieldConfig('purchase_date', FieldConfig.TYPE_DATE, 'Aankoopdatum'),
    new FieldConfig('square_meter', FieldConfig.TYPE_M2, 'Oppervlakte'),
    new FieldConfig('cubic_meter', FieldConfig.TYPE_M3, 'Inhoud'),
    new FieldConfig('country_configuration_id', FieldConfig.TYPE_NATIONALITY, 'Land'),
    new FieldConfig('postal_code', FieldConfig.TYPE_STRING, 'Postcode'),
    new FieldConfig('city', FieldConfig.TYPE_STRING, 'Stad'),
    new FieldConfig('address', FieldConfig.TYPE_STRING, 'Adres'),
    // new HasOneField('address', new HasoneAddressCrudBuilderConfig(), 'Address'),
  ];
  readFields = [
    new FieldConfig('person_id', 'person', 'Persoon'),
    new FieldConfig('price', FieldConfig.TYPE_MONEY, 'Aankoopbedrag'),
    new FieldConfig('woz', FieldConfig.TYPE_MONEY, 'Woz waarde'),
    new FieldConfig('construction_type_configuration_id', 'construction', 'Constructietype'),
    new FieldConfig('construction_year', FieldConfig.TYPE_STRING, 'Bouwjaar'),
    new FieldConfig('home_type_configuration_id', 'home_type', 'Type Huis'),
    new FieldConfig('market_value', FieldConfig.TYPE_MONEY, 'Marktwaarde'),
    new FieldConfig('purchase_date', FieldConfig.TYPE_DATE, 'Aankoopdatum'),
    new FieldConfig('square_meter', FieldConfig.TYPE_M2, 'Oppervlakte'),
    new FieldConfig('cubic_meter', FieldConfig.TYPE_M3, 'Inhoud'),
    new FieldConfig('country_configuration_id', FieldConfig.TYPE_NATIONALITY, 'Land'),
    new FieldConfig('postal_code', FieldConfig.TYPE_STRING, 'Postcode'),
    new FieldConfig('city', FieldConfig.TYPE_STRING, 'Stad'),
    new FieldConfig('address', FieldConfig.TYPE_STRING, 'Adres'),
    // new HasOneField('address', new HasoneAddressCrudBuilderConfig(), 'Address'),
  ];

  listView(model: Home) {
    const view = new ListFormatter()
      .fHead('Adres', Formatter.formatAddress(model.address))
      .fSub('Prijs', Formatter.formatEuroInWords(model.price))
      .fSub('Woz', Formatter.formatEuroInWords(model.woz))
    ;
    return view.toString();
  }

  getModel() {
    return createHome({});
  }

  getEditTitle(model: Home) {
    return 'Aanpassen huis - ' + Formatter.formatAddress(model.address);
  }

  getReadTitle(model: Home) {
    return 'Huizen #' + model.id;
  }

  editPreprocess(model: Home) {
    const nm = {... model};
    if (nm && nm.hasOwnProperty('address') && nm.address) {
      nm.address = {...nm.address};
      nm.address.country_configuration_id = nm.address.country.id;
    }
    console.log("im here! in homes crud");
    
    console.log(nm);
    return nm;
  }
}

export const HomesCrudBuilderConfig = new HomesCrudBuilderConfigClass();
